"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var idm_dynamic_forms_controls_1 = require("@synisys/idm-dynamic-forms-controls");
var idm_kb_service_client_js_1 = require("@synisys/idm-kb-service-client-js");
var of_1 = require("rxjs/observable/of");
var idm_message_language_service_client_js_1 = require("@synisys/idm-message-language-service-client-js");
var idm_locale_service_client_js_1 = require("@synisys/idm-locale-service-client-js");
var fromPromise_1 = require("rxjs/observable/fromPromise");
var GetColContentPipe = /** @class */ (function () {
    function GetColContentPipe(extractionService, messageService, localeService) {
        this.extractionService = extractionService;
        this.messageService = messageService;
        this.localeService = localeService;
    }
    GetColContentPipe.prototype.transform = function (rowItem, metaField, currentLanguageId, parentFieldName, selectedCategory) {
        var compoundCategoryName = metaField.getCompoundCategorySystemName();
        if (parentFieldName && metaField.getMetaFieldId().getMetaCategoryId().getSystemName() !== selectedCategory) {
            rowItem = rowItem.getProperty(parentFieldName).value;
        }
        if (rowItem && rowItem.hasProperty(metaField.getSystemName())) {
            switch (metaField.getType()) {
                case idm_kb_service_client_js_1.MetaFieldType.MULTILINGUAL_STRING:
                    return of_1.of(rowItem
                        .getProperty(metaField.getSystemName())
                        .value.getValue(currentLanguageId));
                case idm_kb_service_client_js_1.MetaFieldType.CLASSIFIER:
                case idm_kb_service_client_js_1.MetaFieldType.WORKFLOW_STATE:
                    return this.extractionService.extractNameFromClassifierCached(rowItem.getProperty(metaField.getSystemName())
                        .value, compoundCategoryName, currentLanguageId);
                case idm_kb_service_client_js_1.MetaFieldType.MULTI_SELECT:
                    return this.extractionService.extractNameFromMultiSelectCached(rowItem.getProperty(metaField.getSystemName())
                        .value, compoundCategoryName, currentLanguageId);
                case idm_kb_service_client_js_1.MetaFieldType.MAIN_ENTITY:
                    return this.extractionService.extractNameFromEntityCached(rowItem.getProperty(metaField.getSystemName())
                        .value, compoundCategoryName, currentLanguageId);
                case idm_kb_service_client_js_1.MetaFieldType.BOOLEAN:
                    var fieldValue = rowItem.getProperty(metaField.getSystemName()).value;
                    return this.messageService.getMessage(fieldValue ? 'ejustice_yes' : 'ejustice_no');
                // case MetaFieldType.SUB_ENTITY:
                //     const subEntities = rowItem.getProperty<Array<SubEntity>>(metaField.getSystemName()).value;
                //
                //     if (subEntities.length) {
                //         return this.extractionService.extractNameFromMultiSelectCached(
                //             subEntities,
                //             metaField.getCompoundCategorySystemName(),
                //             currentLanguageId
                //         ).pipe(
                //             catchError(err => {
                //                 console.warn(`SubEntity: ${metaField.getCompoundCategorySystemName()} doesn't have a name field`);
                //                 return of ('');
                //             })
                //         );
                //     }
                //     return of('');
                case idm_kb_service_client_js_1.MetaFieldType.DATE || idm_kb_service_client_js_1.MetaFieldType.DATE_TIME:
                    var dateString = rowItem.getProperty(metaField.getSystemName()).value;
                    if (dateString) {
                        return metaField.getType() === idm_kb_service_client_js_1.MetaFieldType.DATE ?
                            fromPromise_1.fromPromise(this.localeService.formatDate(dateString.getTime(), currentLanguageId)) :
                            fromPromise_1.fromPromise(this.localeService.formatDateTime(dateString.getTime(), currentLanguageId));
                    }
                    else {
                        return of_1.of('');
                    }
                default:
                    return of_1.of(rowItem.getProperty(metaField.getSystemName()).value);
            }
        }
        else {
            return of_1.of('');
        }
    };
    GetColContentPipe = __decorate([
        core_1.Pipe({ name: 'getColContent' }),
        __metadata("design:paramtypes", [idm_dynamic_forms_controls_1.ExtractionService,
            idm_message_language_service_client_js_1.MessageService,
            idm_locale_service_client_js_1.LocaleService])
    ], GetColContentPipe);
    return GetColContentPipe;
}());
exports.GetColContentPipe = GetColContentPipe;
//# sourceMappingURL=col-content.pipe.js.map